import {h, Fragment} from "preact"
export default function ColorFilters({ facet, toggleFilter }) {
    
    return (
        <ul class="ns-facet__colors-filter-list ns-flex ns-flex-wrap">
            {facet.data?.map(value => {
                const colorName = value.value.toLowerCase().replaceAll(' ', '-');
                return (
                    <li
                        class={`ns-color-filter ns-relative ns-flex ns-justify-between ns-items-center ${value.selected ? "ns-checked" : ""}`}
                        data-nosto-element="facet-setting"
                    >
                        <label className="ns-color-filter__label ns-flex ns-flex-col ns-items-center">
                            <div className="ns-color-filter__img-wrap">
                                <img 
                                    className="ns-color-filter__img"
                                    src={`https://www.brighton.com/cdn/shop/files/mfield_cql_generic_colors__${colorName}.png`}
                                    alt={`Image for filter ${value.value}`}
                                    width="40"
                                    height="40"
                                    loading="lazy"
                                />
                            </div>
                            <span className="ns-color-filter__text">
                                {value.value}
                            </span>
                            <input
                                className="ns-color-filter__input"
                                type="checkbox" 
                                checked={value.selected} 
                                onChange={e => {
                                    e.preventDefault()
                                    toggleFilter(facet.field, value.value, !value.selected)
                                }} 
                            />
                        </label>
                    </li>
                )
            })}
        </ul>
    )
}